import AbstractInstaller from "../core/application/AbstractInstaller";
import SkinKeyRegistry from "../core/ui/SkinKeyRegistry";
import ScenarioPlayerEvent from "../ngt/scenario/ScenarioPlayerEvent";
import CustomScreenCommand from "./briefing/controller/CustomScreenCommand";
import BriefingScreenMediator from "./briefing/view/BriefingScreenMediator";
import PlayConversationStatementCommand from "./conversation-statements/command/PlayConversationStatementCommand";
import ConversationStatementScreenMediator from "./conversation-statements/view/ConversationStatementScreenMediator";
import HubKeyDecisionListItemFactory from "./hub/controller/HubKeyDecisionListItemFactory";
import HubKeyDecisionListItemMediator from "./hub/view/HubKeyDecisionListItemMediator";
import HubKeyDecisionListMediator from "./hub/view/HubKeyDecisionListMediator";
import HubScreenMediator from "./hub/view/HubScreenMediator";
import HubAvailabilityCommand from "./hub/controller/HubAvailabilityCommand";
import RequestConversationInternalStakeholderCommand from "./internal-stakeholders/controller/RequestConversationInternalStakeholderCommand";
import InternalStakeholderInteractionEvent from "./internal-stakeholders/event/InternalStakeholderInteractionEvent";
import InternalStakeholdersModel from "./internal-stakeholders/model/InternalStakeholdersModel";
import InternalStakeholdersConfig from "./internal-stakeholders/model/InternalStakeholdersConfig";
import InitInternalStakeholdersTask from "./internal-stakeholders/task/InitInternalStakeholdersTask";
import InternalStakeholdersMediator from "./internal-stakeholders/view/InternalStakeholdersMediator";
import NotifyKeyDecisionAvailableCommand from "./key-decisions/controller/NotifyKeyDecisionAvailableCommand";
import KeyDecisionCompletedCommand from "./key-decisions/controller/KeyDecisionCompletedCommand";
import KeyDecisionContentAvailableCommand from "./key-decisions/controller/KeyDecisionContentAvailableCommand";
import KeyDecisionContentCompletedCommand from "./key-decisions/controller/KeyDecisionContentCompletedCommand";
import KeyDecisionContentUnavailableCommand from "./key-decisions/controller/KeyDecisionContentUnavailableCommand";
import RequestKeyDecisionCommand from "./key-decisions/controller/RequestKeyDecisionCommand";
import KeyDecisionContentEvent from "./key-decisions/event/KeyDecisionContentEvent";
import KeyDecisionEvent from "./key-decisions/event/KeyDecisionEvent";
import KeyDecisionInteractionEvent from "./key-decisions/event/KeyDecisionInteractionEvent";
import KeyDecisionsConfig from "./key-decisions/model/KeyDecisionsConfig";
import KeyDecisionsModel from "./key-decisions/model/KeyDecisionsModel";
import InitKeyDecisionsConfigTask from "./key-decisions/task/InitKeyDecisionsConfigTask";
import KeyDecisionAvailableScreenMediator from "./key-decisions/view/KeyDecisionAvailableScreenMediator";
import KeyDecisionOverlayScreenMediator from "./key-decisions/view/KeyDecisionOverlayScreenMediator";
import KeyDecisionUnderlayScreenMediator from "./key-decisions/view/KeyDecisionUnderlayScreenMediator";
import MapCharacterInteractionCommand from "./map/controller/MapCharacterInteractionCommand";
import MapFactory from "./map/controller/MapFactory";
import MapMutationCommand from "./map/controller/MapMutationCommand";
import MapCharacterInteractionEvent from "./map/event/MapCharacterInteractionEvent";
import MapModel from "./map/model/MapModel";
import MapsConfig from "./map/model/MapsConfig";
import InitMapsConfigTask from "./map/task/InitMapsConfigTask";
import MapCharacterInformationPopupMediator from "./map/view/MapCharacterInformationPopupMediator";
import MapLocationCharacterMenuMediator from "./map/view/MapLocationCharacterMenuMediator";
import MapLocationMediator from "./map/view/MapLocationMediator";
import MapMediator from "./map/view/MapMediator";
import PlaceholderCommand from "./placeholder/controller/PlaceholderCommand";
import PlaceholderScreenMediator from "./placeholder/view/PlaceholderScreenMediator";
import TransitionCommand from "./transition/controller/TransitionCommand";
import TransitionScreenMediator from "./transition/view/TransitionScreenMediator";
import InternalStakeholderContentCommand from "./internal-stakeholders/controller/InternalStakeholderContentCommand";
import TeaCornerContentAvailableCommand from "./tea-corner/controller/TeaCornerContentAvailableCommand";
import TeaCornerContentUnavailableCommand from "./tea-corner/controller/TeaCornerContentUnavailableCommand";
import TeaCornerModel from "./tea-corner/model/TeaCornerModel";
import TeaCornerOpenerMediator from "./tea-corner/view/TeaCornerOpenerMediator";

import DashboardOpenerMediator from "./dashboard/view/DashboardOpenerMediator";
import DashboardScreenMediator from "./dashboard/view/DashboardScreenMediator";
import DashboardNavigateCommand from "./dashboard/controller/DashboardNavigateCommand";
import DashboardEvent from "./dashboard/event/DashboardEvent";
import DashboardEpiTabMediator from "./dashboard/view/Tabs/DashboardEpiTabMediator";
import DashboardHealthSystemsTabMediator from "./dashboard/view/Tabs/DashboardHealthSystemsTabMediator";
import DashboardRCCETabMediator from "./dashboard/view/Tabs/DashboardRCCETabMediator";
import DashboardNumberChartMediator from "./dashboard/view/DashboardNumberChartMediator";
import DashboardNumberChartFactory from "./dashboard/controller/DashboardNumberChartFactory";
import InitDashboardConfigTask from "./dashboard/task/InitDashboardConfigTask";
import DashboardConfig from "./dashboard/model/DashboardConfig";
import DialogScreenMediator from "./dialog/view/DialogScreenMediator";
import ComposerScreenMediator from "./composer/view/ComposerScreenMediator";
import ComposerTopicMediator from "./composer/view/ComposerTopicMediator";
import TimerMediator from "./timer/view/TimerMediator";
import InitTimerTask from "./timer/task/InitTimerTask";
import TimerConfig from "./timer/model/TimerConfig";
import ComposerEvent from "./composer/event/ComposerEvent";
import ComposerNavigateCommand from "./composer/controller/ComposerNavigateCommand";
import FeedbackScreenMediator from "./feedback/view/FeedbackScreenMediator";
import FeedbackAnswersMediator from "./feedback/view/FeedbackAnswersMediator";
import FeedbackEvent from "./feedback/event/FeedbackEvent";
import FeedbackNavigateCommand from "./feedback/controller/FeedbackNavigateCommand";
import FeedbackPopupMediator from "./feedback/view/FeedbackPopupMediator";
import FeedbackPopupFactory from "./feedback/controller/FeedbackPopupFactory";
import KeyDecisionSummaryScreenMediator from "./key-decision-summary/view/KeyDecisionSummaryScreenMediator";
import LoadingScreenMediator from "./loading/view/LoadingScreenMediator";
import NGTVariableEvent from "../ngt/base/NGTVariableEvent";
import VariableChangedCommand from "./variables/controller/VariableChangedCommand";
import InitDashboardDataTask from "./dashboard/task/InitDashboardDataTask";
import DashboardData from "./dashboard/model/DashboardData";
import TutorialKeyDecisionsScreenMediator from "./tutorial/view/TutorialKeyDecisionsScreenMediator";
import TutorialHubScreenMediator from "./tutorial/view/TutorialHubScreenMediator";
import TutorialSimInteractions from "./tutorial/view/TutorialSimInteractions";
import TutorialHubMediator from "./tutorial/view/shared/TutorialHubMediator";
import EpilogueScreenMediator from "./epilogue/view/EpilogueScreenMediator";
import AppSoundManager from "./sound/AppSoundManager";
import SoundConfig from "./sound/model/SoundConfig";
import InitSoundConfigTask from "./sound/task/InitSoundConfigTask";
import DashboardCumulativeDataMediator from "./dashboard/view/DashboardCumulativeDataMediator";
import DashboardCumulativeDataFactory from "./dashboard/controller/DashboardCumulativeDataFactory";
import InitScoreConfigTask from "./score/task/InitScoreConfigTask";
import ScoreConfig from "./score/model/ScoreConfig";
import AppNGTDialogPlayer from "./dialog/view/AppNGTDialogPlayer";
import KeyDecisionContentIgnoredCommand from "./key-decisions/controller/KeyDecisionContentIgnoredCommand";
import LoadGameCommand from "./save-game/controller/LoadGameCommand.js";
import SaveGameCommand from "./save-game/controller/SaveGameCommand.js";
import SaveGameService from "./save-game/controller/SaveGameService.js";
import SaveGameEvent from "./save-game/events/SaveGameEvent.js";
import SaveGameModel from "./save-game/model/SaveGameModel.js";
import GameSavedNoticeMediator from "./save-game/view/GameSavedNoticeMediator.js";
import ProgressGameModel from "./save-game/model/ProgressGameModel";
import ToggleSoundButton from "./sound/view/ToggleSoundButton";
import SoundCommand from "./sound/controller/SoundCommand";
import SoundEvent from "./sound/event/SoundEvent";
import PausePopupMediator from "./pause/view/PausePopupMediator";
import PauseOpenerMediator from "./pause/view/PauseOpenerMediator";
import ExitPopupMediator from "./exit/view/ExitPopupMediator";
import ExitOpenerMediator from "./exit/view/ExitOpenerMediator";
import EndScreenMediator from "./end/view/EndScreenMediator";
import HubSaveGameModel from "./save-game/model/HubSaveGameModel";

export default class AppSpecificInstaller extends AbstractInstaller {
    /**
     * @param {infuse.Injector} injector 
     * @param {soma.Commands} commands 
     * @param {MediatorMapping} mediatorMap 
     */
    constructor(injector, commands, mediatorMap) {
        super(injector, commands, mediatorMap);

        commands.add(ScenarioPlayerEvent.TEXT_AVAILABLE, PlaceholderCommand);
        commands.add(ScenarioPlayerEvent.UNLOCK_LOCATION_AVAILABLE, CustomScreenCommand);
        commands.add(ScenarioPlayerEvent.MAP_MUTATION_AVAILABLE, MapMutationCommand);
        commands.add(ScenarioPlayerEvent.PUSH_CONVERSATION_STATEMENT_AVAILABLE, PlayConversationStatementCommand);
        commands.add(ScenarioPlayerEvent.NARRATIVE_EVENT_AVAILABLE, TransitionCommand);
        commands.add(ScenarioPlayerEvent.CHANGE_ENTITY_VISIBILITY_AVAILABLE, HubAvailabilityCommand);
        commands.add(ScenarioPlayerEvent.INTERNAL_STAKEHOLDER_CONTENT_AVAILABLE, InternalStakeholderContentCommand);
        commands.add(ScenarioPlayerEvent.PULL_CONVERSATION_STATEMENT_AVAILABLE, TeaCornerContentAvailableCommand);
        commands.add(ScenarioPlayerEvent.PULL_CONVERSATION_STATEMENT_UNAVAILABLE, TeaCornerContentUnavailableCommand);

        commands.add(MapCharacterInteractionEvent.CLICK, MapCharacterInteractionCommand);
        commands.add(MapCharacterInteractionEvent.ENTER, MapCharacterInteractionCommand);

        commands.add(KeyDecisionContentEvent.KEY_DECISION_CONTENT_AVAILABLE, KeyDecisionContentAvailableCommand);
        commands.add(KeyDecisionContentEvent.KEY_DECISION_CONTENT_UNAVAILABLE, KeyDecisionContentUnavailableCommand);
        commands.add(KeyDecisionContentEvent.KEY_DECISION_CONTENT_COMPLETED, KeyDecisionContentCompletedCommand);
        commands.add(KeyDecisionContentEvent.KEY_DECISION_CONTENT_IGNORED, KeyDecisionContentIgnoredCommand);
        commands.add(KeyDecisionEvent.KEY_DECISION_COMPLETED, KeyDecisionCompletedCommand);
        commands.add(KeyDecisionInteractionEvent.REQUEST_KEY_DECISION, RequestKeyDecisionCommand);
        commands.add(KeyDecisionInteractionEvent.NOTIFY_KEY_DECISION_AVAILABLE, NotifyKeyDecisionAvailableCommand);

        commands.add(InternalStakeholderInteractionEvent.REQUEST_CONVERSATION, RequestConversationInternalStakeholderCommand);

        commands.add(DashboardEvent.OPEN_SCREEN_REQUEST, DashboardNavigateCommand);

        commands.add(ComposerEvent.OPEN_SCREEN_REQUEST, ComposerNavigateCommand);

        commands.add(FeedbackEvent.OPEN_SCREEN_REQUEST, FeedbackNavigateCommand);

        commands.add(NGTVariableEvent.VARIABLE_CHANGED, VariableChangedCommand);

        commands.add(SoundEvent.MUTE, SoundCommand);
        commands.add(SoundEvent.UNMUTE, SoundCommand);

        injector.mapClass("mapFactory", MapFactory, true);
        injector.mapClass("mapsConfig", MapsConfig, true);
        injector.mapClass("mapModel", MapModel, true);
        injector.mapClass("keyDecisionsConfig", KeyDecisionsConfig, true);
        injector.mapClass("keyDecisionsModel", KeyDecisionsModel, true);
        injector.mapClass("hubKeyDecisionListItemFactory", HubKeyDecisionListItemFactory, true);
        injector.mapClass("internalStakeholdersConfig", InternalStakeholdersConfig, true);
        injector.mapClass("internalStakeholdersModel", InternalStakeholdersModel, true);
        injector.mapClass("teaCornerModel", TeaCornerModel, true);
        injector.mapClass("dashboardNumberChartFactory", DashboardNumberChartFactory, true);
        injector.mapClass("dashboardCumulativeDataFactory", DashboardCumulativeDataFactory, true);
        injector.mapClass("dashboardConfig", DashboardConfig, true);
        injector.mapClass("dashboardData", DashboardData, true);
        injector.mapClass("timerConfig", TimerConfig, true);
        injector.mapClass("feedbackPopupFactory", FeedbackPopupFactory, true);
        injector.mapClass('scoreConfig', ScoreConfig, true);

        injector.mapClass('progressGameModel', ProgressGameModel, true);
        injector.mapClass('hubSaveGameModel', HubSaveGameModel, true);
        
        // Savegame        
        injector.mapClass('saveGameService', SaveGameService, true);
        injector.mapClass('saveGameModel', SaveGameModel, true);
        commands.add(SaveGameEvent.SAVE_GAME, SaveGameCommand);
        commands.add(SaveGameEvent.LOAD_GAME, LoadGameCommand);
        SkinKeyRegistry.GAME_SAVED_NOTICE_MEDIATOR = this._mapMediator(GameSavedNoticeMediator);

        // Sound
        injector.mapClass("soundConfig", SoundConfig, true);
        injector.mapClass("appSoundManager", AppSoundManager, true);

        injector.mapClass("dialogPlayer", AppNGTDialogPlayer, false);//NB: not a singleton!

        injector.mapClass("toggleSoundButton", ToggleSoundButton, true);

        SkinKeyRegistry.PLACEHOLDER_SCREEN_SKIN = this._mapMediator(PlaceholderScreenMediator, lib.MainAssets.PlaceholderScreenSkin);
        SkinKeyRegistry.BRIEFING_SCREEN_SKIN = this._mapMediator(BriefingScreenMediator, lib.MainAssets.BriefingScreenSkin);

        SkinKeyRegistry.HUB_SCREEN_SKIN = this._mapMediator(HubScreenMediator, lib.MainAssets.HubScreenSkin);
        SkinKeyRegistry.HUB_KEY_DECISION_LIST_SKIN = this._mapMediator(HubKeyDecisionListMediator);
        SkinKeyRegistry.HUB_KEY_DECISION_LIST_ITEM_SKIN = this._mapMediator(HubKeyDecisionListItemMediator);

        SkinKeyRegistry.TEA_CORNER_OPENER = this._mapMediator(TeaCornerOpenerMediator);

        SkinKeyRegistry.DASHBOARD_OPENER = this._mapMediator(DashboardOpenerMediator);

        SkinKeyRegistry.INTERNAL_STAKEHOLDERS = this._mapMediator(InternalStakeholdersMediator);

        SkinKeyRegistry.MAP_SKIN = this._mapMediator(MapMediator); // Skin differs per map, see MapFactory.js
        SkinKeyRegistry.MAP_LOCATION = this._mapMediator(MapLocationMediator);
        SkinKeyRegistry.MAP_LOCATION_CHARACTER_MENU = this._mapMediator(MapLocationCharacterMenuMediator);
        SkinKeyRegistry.MAP_NODE_INFORMATION_POPUP_SKIN = this._mapMediator(MapCharacterInformationPopupMediator, lib.MainAssets.MapNodeInformationPopupSkin);

        SkinKeyRegistry.KEY_DECISION_OVERLAY_SCREEN_SKIN = this._mapMediator(KeyDecisionOverlayScreenMediator, lib.MainAssets.KeyDecisionOverlayScreenSkin);
        SkinKeyRegistry.KEY_DECISION_UNDERLAY_SCREEN_SKIN = this._mapMediator(KeyDecisionUnderlayScreenMediator, lib.MainAssets.KeyDecisionUnderlayScreenSkin);
        SkinKeyRegistry.KEY_DECISION_AVAILABLE_SCREEN_SKIN = this._mapMediator(KeyDecisionAvailableScreenMediator, lib.MainAssets.KeyDecisionAvailableScreenSkin);

        SkinKeyRegistry.CONVERSATION_STATEMENT_SCREEN_SKIN = this._mapMediator(ConversationStatementScreenMediator, lib.MainAssets.ConversationStatementScreenSkin);

        SkinKeyRegistry.DASHBOARD_SCREEN_SKIN = this._mapMediator(DashboardScreenMediator, lib.MainAssets.DashboardScreenSkin);
        SkinKeyRegistry.DASHBOARD_EPI_TAB_SKIN = this._mapMediator(DashboardEpiTabMediator);
        SkinKeyRegistry.DASHBOARD_HEALTH_SYSTEMS_TAB_SKIN = this._mapMediator(DashboardHealthSystemsTabMediator);
        SkinKeyRegistry.DASHBOARD_RCCE_TAB_SKIN = this._mapMediator(DashboardRCCETabMediator);
        SkinKeyRegistry.DASHBOARD_NUMBER_CHART_SKIN = this._mapMediator(DashboardNumberChartMediator);
        SkinKeyRegistry.DASHBOARD_CUMULATIVE_DATA_SKIN = this._mapMediator(DashboardCumulativeDataMediator);
        

        SkinKeyRegistry.TRANSITION_SCREEN_SKIN = this._mapMediator(TransitionScreenMediator, lib.MainAssets.TransitionScreenSkin);

        SkinKeyRegistry.DIALOG_SCREEN_SKIN = this._mapMediator(DialogScreenMediator, lib.MainAssets.DialogScreenSkin);

        SkinKeyRegistry.COMPOSER_SCREEN_SKIN = this._mapMediator(ComposerScreenMediator, lib.MainAssets.PlanComposerScreenSkin);
        SkinKeyRegistry.COMPOSER_TOPIC_SKIN = this._mapMediator(ComposerTopicMediator);

        SkinKeyRegistry.TIMER = this._mapMediator(TimerMediator);

        SkinKeyRegistry.FEEDBACK_SCREEN_SKIN = this._mapMediator(FeedbackScreenMediator, lib.MainAssets.FeedbackScreenSkin);
        SkinKeyRegistry.FEEDBACK_ANSWERS_SKIN = this._mapMediator(FeedbackAnswersMediator);
        SkinKeyRegistry.FEEDBACK_POPUP_SKIN = this._mapMediator(FeedbackPopupMediator);

        SkinKeyRegistry.KEY_DECISION_SUMMARY_SCREEN_SKIN = this._mapMediator(KeyDecisionSummaryScreenMediator, lib.MainAssets.KeyDecisionConfirmationScreenSkin);

        SkinKeyRegistry.LOADING_SCREEN_SKIN = this._mapMediator(LoadingScreenMediator, lib.MainAssets.LoadingScreenSkin);


        SkinKeyRegistry.TUTORIAL_SCREEN_SKIN = this._mapMediator(TutorialKeyDecisionsScreenMediator, lib.MainAssets.TutorialScreenSkin1);
        SkinKeyRegistry.TUTORIAL_HUB_SCREEN_SKIN = this._mapMediator(TutorialHubScreenMediator, lib.MainAssets.TutorialScreenSkin2);
        SkinKeyRegistry.TUTORIAL_SIM_INTERACTIONS_SCREEN_SKIN = this._mapMediator(TutorialSimInteractions, lib.MainAssets.TutorialScreenSkin3);
        SkinKeyRegistry.TUTORIAL_HUB_SKIN = this._mapMediator(TutorialHubMediator);

        SkinKeyRegistry.EPILOGUE_SCREEN_SKIN = this._mapMediator(EpilogueScreenMediator, lib.MainAssets.EpilogueDashboardScreenSkin);

        SkinKeyRegistry.PAUSE_POPUP_SKIN = this._mapMediator(PausePopupMediator, lib.MainAssets.PausePopupSkin);
        SkinKeyRegistry.PAUSE_OPENER = this._mapMediator(PauseOpenerMediator);

        SkinKeyRegistry.EXIT_POPUP_SKIN = this._mapMediator(ExitPopupMediator, lib.MainAssets.ExitPopupSkin);
        SkinKeyRegistry.EXIT_OPENER = this._mapMediator(ExitOpenerMediator);

        SkinKeyRegistry.END_SCREEN_SKIN = this._mapMediator(EndScreenMediator, lib.MainAssets.EndScreenSkin);

        this._addAssetsToConfigurationManifest(
            { id: "maps-config", src: "assets/maps.json" },
            { id: "key-decisions-config", src: "assets/key-decisions.json" },
            { id: "internal-stakeholders-config", src: "assets/internal-stakeholders.json" },
            { id: "dashboard-config", src: "assets/dashboard.json" },
            { id: "dashboard-data", src: "assets/dashboard-data.json" },
            { id: "timer-config", src: "assets/timer.json" },
            { id: "score-config", src: "assets/score.json" },
            { id: "sound-config", src: "assets/sound.json" }
        );

        this._addStartupTask(InitMapsConfigTask, "initMapsConfig", 1);
        this._addStartupTask(InitKeyDecisionsConfigTask, "initKeyDecisionsConfig", 1);
        this._addStartupTask(InitInternalStakeholdersTask, "initInternalStakeholdersTask", 1);
        this._addStartupTask(InitTimerTask, "initTimerTask", 1);
        this._addStartupTask(InitDashboardConfigTask, "initDashboardConfig", 1);
        this._addStartupTask(InitDashboardDataTask, "initDashboardData", 1);
        this._addStartupTask(InitScoreConfigTask, "initScoreConfigTask", 1);
        this._addStartupTask(InitSoundConfigTask, "initSoundConfigTask", 1);
    }
}